import React, { useState, useEffect } from "react";
import { StyleSheet, View, ActivityIndicator, Alert } from "react-native";

import { StackActions, useFocusEffect } from "@react-navigation/native";
import Background from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import DiaHorario from "../components/DiaHorario";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [failed, setFailed] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(props.route.params.fechaInicio)
  );
  const [endDate, setEndDate] = useState(
    new Date(props.route.params.fechaFinal)
  );
  const [horarios, setHorarios] = useState([]);
  const [lunes, setLunes] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 0,
    periodo: props.route.params._id,
  });
  const [martes, setMartes] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 1,
    periodo: props.route.params._id,
  });
  const [miercoles, setMiercoles] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 2,
    periodo: props.route.params._id,
  });
  const [jueves, setJueves] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 3,
    periodo: props.route.params._id,
  });
  const [viernes, setViernes] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 4,
    periodo: props.route.params._id,
  });
  const [sabado, setSabado] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 5,
    periodo: props.route.params._id,
  });
  const [domingo, setDomingo] = useState({
    abreMananas: false,
    abreTardes: false,
    aperturaManana: "2020-06-17T22:00:00.000Z",
    aperturaTarde: "2020-06-17T22:00:00.000Z",
    cierreManana: "2020-06-17T22:00:00.000Z",
    cierreTarde: "2020-06-17T22:00:00.000Z",
    diaSemana: 6,
    periodo: props.route.params._id,
  });
  const [loaded, setLoaded] = useState(deleted);
  const [update, setUpdate] = useState(false);
  const [create, setCreate] = useState(false);
  const [deleted, setDelete] = useState(false);

  useEffect(() => {
    const call = async () => {
      let secondResponse = await makeRequest(
        "horarios/" + props.route.params._id,
        "get"
      );
      if (secondResponse[0] == 200 && secondResponse[1].length == 7) {
        setHorarios(secondResponse[1]);
        setLunes(secondResponse[1].filter((e) => e.diaSemana == 0)[0]);
        setMartes(secondResponse[1].filter((e) => e.diaSemana == 1)[0]);
        setMiercoles(secondResponse[1].filter((e) => e.diaSemana == 2)[0]);
        setJueves(secondResponse[1].filter((e) => e.diaSemana == 3)[0]);
        setViernes(secondResponse[1].filter((e) => e.diaSemana == 4)[0]);
        setSabado(secondResponse[1].filter((e) => e.diaSemana == 5)[0]);
        setDomingo(secondResponse[1].filter((e) => e.diaSemana == 6)[0]);
        setDelete(true);
      } else {
        setDelete(false);
      }
      setLoaded(true);
    };
    call();
  }, []);

  const checkParams = () => {
    if (
      lunes.abreMananas &&
      new Date(lunes.cierreManana) <= new Date(lunes.aperturaManana)
    )
      setFailed(true);
    if (
      lunes.abreTardes &&
      new Date(lunes.cierreTarde) <= new Date(lunes.aperturaTarde)
    )
      setFailed(true);
    if (
      martes.abreMananas &&
      new Date(martes.cierreManana) <= new Date(martes.aperturaManana)
    )
      setFailed(true);
    if (
      martes.abreTardes &&
      new Date(martes.cierreTarde) <= new Date(martes.aperturaTarde)
    )
      setFailed(true);
    if (
      miercoles.abreMananas &&
      new Date(miercoles.cierreManana) <= new Date(miercoles.aperturaManana)
    )
      setFailed(true);
    if (
      miercoles.abreTardes &&
      new Date(miercoles.cierreTarde) <= new Date(miercoles.aperturaTarde)
    )
      setFailed(true);
    if (
      jueves.abreMananas &&
      new Date(jueves.cierreManana) <= new Date(jueves.aperturaManana)
    )
      setFailed(true);
    if (
      jueves.abreTardes &&
      new Date(jueves.cierreTarde) <= new Date(jueves.aperturaTarde)
    )
      setFailed(true);
    if (
      viernes.abreMananas &&
      new Date(viernes.cierreManana) <= new Date(viernes.aperturaManana)
    )
      setFailed(true);
    if (
      viernes.abreTardes &&
      new Date(viernes.cierreTarde) <= new Date(viernes.aperturaTarde)
    )
      setFailed(true);
    if (
      sabado.abreMananas &&
      new Date(sabado.cierreManana) <= new Date(sabado.aperturaManana)
    )
      setFailed(true);
    if (
      sabado.abreTardes &&
      new Date(sabado.cierreTarde) <= new Date(sabado.aperturaTarde)
    )
      setFailed(true);
    if (
      domingo.abreMananas &&
      new Date(domingo.cierreManana) <= new Date(domingo.aperturaManana)
    )
      setFailed(true);
    if (
      domingo.abreTardes &&
      new Date(domingo.cierreTarde) <= new Date(domingo.aperturaTarde)
    )
      setFailed(true);
  };

  const sendPostRequestHorarios = () => {
    setCreate(true);
  };
  const sendPutRequestHorarios = () => {
    setUpdate(true);
  };
  const addPeriodo = async () => {
    const req = async () => {
      await checkParams();
      const method = deleted ? "put" : "post";
      if (method == "post") {
        sendPostRequestHorarios();
        props.navigation.navigate("ConfigurarHorarios", { reload: true });
      }
      if (method == "put") {
        sendPutRequestHorarios();
        props.navigation.navigate("ConfigurarHorarios");
      }
    };
    await req();
  };

  const eliminarPeriodo = () => {
    const req = async () => {
      const response = await makeRequest(
        "periodos/" + props.route.params._id,
        "delete"
      );
    };
    req();
  };

  return (
    <Background scroll={true}>
      <Logo></Logo>
      {loaded ? (
        <>
          <Title style={{ fontSize: 19 }}>
            Modificar horarios para: {props.route.params.instalacion.nombre}
          </Title>
          <View style={styles.container}>
            <Title style={{ fontSize: 17, color: "white", marginTop: 0 }}>
              Inicio:{" "}
              {startDate.getDate() >= 10
                ? startDate.getDate()
                : "0" + startDate.getDate()}
              /
              {startDate.getMonth() + 1 < 10
                ? "0" + (startDate.getMonth() + 1)
                : startDate.getMonth() + 1}
              /{startDate.getFullYear()}
            </Title>
            <Title style={{ fontSize: 17, color: "white", marginTop: 0 }}>
              Final:{" "}
              {endDate.getDate() >= 10
                ? endDate.getDate()
                : "0" + endDate.getDate()}
              /
              {endDate.getMonth() + 1 < 10
                ? "0" + (endDate.getMonth() + 1)
                : endDate.getMonth() + 1}
              /{endDate.getFullYear()}
            </Title>
          </View>
          <DiaHorario
            setFailed={setFailed}
            diaSemana={0}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia={"Lunes"}
            mananaApertura={lunes.aperturaManana}
            tardeApertura={lunes.aperturaTarde}
            mananaCierre={lunes.cierreManana}
            tardeCierre={lunes.cierreTarde}
            abreTardes={lunes.abreTardes}
            abreMananas={lunes.abreMananas}
            _id={lunes._id}
          />
          <DiaHorario
            setFailed={setFailed}
            diaSemana={1}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia='Martes'
            mananaApertura={martes.aperturaManana}
            tardeApertura={martes.aperturaTarde}
            mananaCierre={martes.cierreManana}
            tardeCierre={martes.cierreTarde}
            abreTardes={martes.abreTardes}
            abreMananas={martes.abreMananas}
            _id={martes._id}
          />
          <DiaHorario
            setFailed={setFailed}
            diaSemana={2}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia='Miercoles'
            mananaApertura={miercoles.aperturaManana}
            tardeApertura={miercoles.aperturaTarde}
            mananaCierre={miercoles.cierreManana}
            tardeCierre={miercoles.cierreTarde}
            abreTardes={miercoles.abreTardes}
            abreMananas={miercoles.abreMananas}
            _id={miercoles._id}
          />
          <DiaHorario
            setFailed={setFailed}
            diaSemana={3}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia='Jueves'
            mananaApertura={jueves.aperturaManana}
            tardeApertura={jueves.aperturaTarde}
            mananaCierre={jueves.cierreManana}
            tardeCierre={jueves.cierreTarde}
            abreTardes={jueves.abreTardes}
            abreMananas={jueves.abreMananas}
            _id={jueves._id}
          />
          <DiaHorario
            setFailed={setFailed}
            diaSemana={4}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia='Viernes'
            mananaApertura={viernes.aperturaManana}
            tardeApertura={viernes.aperturaTarde}
            mananaCierre={viernes.cierreManana}
            tardeCierre={viernes.cierreTarde}
            abreTardes={viernes.abreTardes}
            abreMananas={viernes.abreMananas}
            _id={viernes._id}
          />
          <DiaHorario
            setFailed={setFailed}
            diaSemana={5}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia='Sábado'
            mananaApertura={sabado.aperturaManana}
            tardeApertura={sabado.aperturaTarde}
            mananaCierre={sabado.cierreManana}
            tardeCierre={sabado.cierreTarde}
            abreTardes={sabado.abreTardes}
            abreMananas={sabado.abreMananas}
            _id={sabado._id}
          />
          <DiaHorario
            setFailed={setFailed}
            diaSemana={6}
            update={update}
            create={create}
            periodo={props.route.params._id}
            dia='Domingo'
            mananaApertura={domingo.aperturaManana}
            tardeApertura={domingo.aperturaTarde}
            mananaCierre={domingo.cierreManana}
            tardeCierre={domingo.cierreTarde}
            abreTardes={domingo.abreTardes}
            abreMananas={domingo.abreMananas}
            _id={domingo._id}
          />

          <View style={{ marginBottom: 40 }}>
            {failed && (
              <Title style={{ fontSize: 16 }}>
                Error: Revise los parámetros elegidos
              </Title>
            )}
            <ButtonLayout
              text='Confirmar'
              onPress={async () => {
                if (props.route.params.delete)
                  Alert.alert(
                    "¿Seguro que quiere modificar este periodo? ",
                    "Se cancelará todas las citas reservadas",
                    [
                      {
                        text: "Modificar",
                        onPress: async () => await addPeriodo(),
                      },
                      { text: "Cancelar", onPress: () => {} },
                    ],
                    { cancelable: true }
                  );
                else
                  Alert.alert(
                    "¿Seguro que quiere añadir este periodo? ",
                    "Se cancelará todas las citas reservadas al modificarlo",
                    [
                      {
                        text: "Añadir",
                        onPress: async () => await addPeriodo(),
                      },
                      { text: "Cancelar", onPress: () => {} },
                    ],
                    { cancelable: true }
                  );
              }}
            />
            <ButtonLayoutMenu
              style={{ maxWidth: 150 }}
              text='Cancelar'
              onPress={() => props.navigation.navigate("ConfigurarHorarios")}
            />
            {deleted && (
              <ButtonLayout
                style={{ backgroundColor: "red", width: 200 }}
                text='Eliminar el periodo'
                onPress={() => {
                  Alert.alert(
                    "¿Seguro que quiere eliminar este periodo? ",
                    "Se cancelarán las citas reservadas",
                    [
                      {
                        text: "Eliminar",
                        onPress: () => {
                          eliminarPeriodo();
                          props.navigation.navigate("ConfigurarHorarios", {
                            reload: true,
                          });
                        },
                      },
                      { text: "Cancelar", onPress: () => {} },
                    ],
                    { cancelable: true }
                  );
                }}
              />
            )}
          </View>
        </>
      ) : (
        <ActivityIndicator
          size='large'
          color='rgba(255,255,255, 0.6)'
          style={{ marginTop: 100 }}
        />
      )}
    </Background>
  );
}
const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    padding: 20,
    color: "white",
    backgroundColor: "#8ea7ad",
    alignSelf: "center",
    borderRadius: 25,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
});
